<template>
  <div class="px-20 py-20 border-box">
    <el-card class="box-card">
      <div class="title" style="font-size:16px;font-weight:600;margin-bottom:8px">劳动合同审批</div>
      <div style="color:#909399;font-size:13px">以下为待您审批的劳动合同。审批通过后流程自动推进至下一节点，全部节点通过后方才生效。</div>
    </el-card>

    <div class="table-con mt-20">
      <tableComponent :columns="columns" :tableData="dataList" :loading="loading" :pagination="pagination"
        @preSizeChange="sizeChange" @preCurrentChange="currentChange">
        <template #periodSlot="{ row }">
          <span>{{ row.startDate }} ~ {{ row.endDate || '无固定期限' }}</span>
        </template>
        <template #operate="{ row }">
          <el-button type="text" @click="openReview(row)">审核</el-button>
          <el-button type="text" @click="openDetail(row)">详情</el-button>
        </template>
      </tableComponent>
    </div>

    <el-dialog :title="reviewTitle" :visible.sync="reviewVisible" width="720px" @opened="loadReview">
      <template v-if="contract">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="员工姓名">{{ contract.employeeName }}</el-descriptions-item>
          <el-descriptions-item label="部门">{{ contract.dept }}</el-descriptions-item>
          <el-descriptions-item label="岗位">{{ contract.post }}</el-descriptions-item>
          <el-descriptions-item label="合同编号">{{ contract.contractNo }}</el-descriptions-item>
          <el-descriptions-item label="合同类型">{{ contract.contractTypeName }}</el-descriptions-item>
          <el-descriptions-item label="合同期限">{{ contract.startDate }} ~ {{ contract.endDate || '无固定期限' }}</el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">{{ contract.remark || '-' }}</el-descriptions-item>
        </el-descriptions>

        <div v-if="attachmentList && attachmentList.length" class="mt-20">
          <div style="font-weight:600;margin-bottom:10px">合同附件</div>
          <div v-for="(f, i) in attachmentList" :key="i" class="audit-file-item">
            <i class="el-icon-document" style="color:#909399;margin-right:6px"></i>
            <span class="audit-file-name">{{ f.name }}</span>
            <el-button type="text" @click="previewFile(f)">预览</el-button>
            <el-button type="text" @click="handleDownload(f)">下载</el-button>
          </div>
          <filePreview :isShowFilePreview="isShowFilePreview" :fileData="fileData" @handleClose="closeFileView" />
        </div>

        <div v-if="history && history.length" class="mt-20">
          <div style="font-weight:600;margin-bottom:10px">审批流转</div>
          <el-timeline>
            <el-timeline-item v-for="h in history" :key="h.id" :timestamp="h.auditTime || h.createTime">
              <span>审批人：{{ h.auditorName || h.auditorId || '-' }}</span>
              <el-tag size="mini" :type="h.auditStatus === 1 ? 'success' : (h.auditStatus === 2 ? 'danger' : 'info')" style="margin-left:8px">
                {{ auditStatusText(h.auditStatus) }}
              </el-tag>
              <div v-if="h.auditComment" style="color:#606266;margin-top:4px">意见：{{ h.auditComment }}</div>
            </el-timeline-item>
          </el-timeline>
        </div>

        <el-form v-if="reviewMode" class="mt-20">
          <el-form-item label="审批意见">
            <el-input v-model="auditComment" type="textarea" :rows="3" placeholder="选填" />
          </el-form-item>
        </el-form>
      </template>
      <div slot="footer">
        <el-button @click="reviewVisible = false">关闭</el-button>
        <template v-if="reviewMode">
          <el-button type="danger" @click="doAudit(2)">驳回</el-button>
          <el-button type="primary" @click="doAudit(1)">通过</el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tableComponent from '@/components/tableComponent/index.vue'
import filePreview from '@/components/filePreview/filePreview.vue'
import { auditPageApi, auditApi, auditDetailApi } from '@/api/laborContract/index'
import { downloadFile as downloadFileApi, fileViewApi } from '@/api/download/index'
import { downloadLinkFile } from '@/utils/common'

export default {
  name: 'LaborContractAudit',
  components: { tableComponent, filePreview },
  data() {
    return {
      loading: false,
      dataList: [],
      reviewVisible: false,
      reviewMode: true,
      reviewTitle: '劳动合同审核',
      currentId: null,
      contract: null,
      history: [],
      auditComment: '',
      // 审批人预览/下载附件
      isShowFilePreview: false,
      fileData: {},
      pagination: { pageCount: 7, total: 0, pageSize: 10, pageSizes: [10, 20, 100] },
      columns: [
        { id: 0, title: '序号', width: '60px', align: 'center', keyName: 'i', slotName: '' },
        { id: 1, title: '员工姓名', width: '100px', keyName: 'employeeName', align: 'center', slotName: '' },
        { id: 2, title: '合同编号', width: '150px', keyName: 'contractNo', align: 'left', slotName: '' },
        { id: 3, title: '合同类型', width: '110px', keyName: 'contractTypeName', align: 'center', slotName: '' },
        { id: 4, title: '合同期限', width: '220px', keyName: '', align: 'center', slotName: 'periodSlot' },
        { id: 5, title: '提交时间', width: '160px', keyName: 'createTime', align: 'center', slotName: '' },
        { id: 6, title: '操作', fixed: 'right', width: '120px', align: 'center', slotName: 'operate' }
      ]
    }
  },
  mounted() {
    this.queryData()
  },
  computed: {
    // 由合同附件(JSON 字符串)解析出文件列表，供只读预览组件使用
    attachmentList() {
      return this.parseFileList(this.contract ? this.contract.attachment : '')
    }
  },
  methods: {
    queryData(item = {}) {
      const params = { pageNum: 1, pageSize: 10, ...item }
      this.loading = true
      auditPageApi(params).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.dataList = res.data.rows || []
          this.pagination.total = res.data.total || 0
        }
      })
    },
    sizeChange(p) { this.queryData({ pageSize: p }) },
    currentChange(p) { this.queryData({ pageNum: p }) },
    openReview(row) {
      this.reviewMode = true
      this.reviewTitle = '劳动合同审核'
      this.currentId = row.id
      this.reviewVisible = true
    },
    openDetail(row) {
      this.reviewMode = false
      this.reviewTitle = '审批详情'
      this.currentId = row.id
      this.reviewVisible = true
    },
    loadReview() {
      this.contract = null
      this.history = []
      this.auditComment = ''
      if (!this.currentId) return
      auditDetailApi({ id: this.currentId }).then(res => {
        if (res.code === 200) {
          this.contract = res.data.contract
          this.history = res.data.history || []
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    doAudit(status) {
      auditApi({ auditRecordId: this.currentId, auditStatus: status, auditComment: this.auditComment }).then(res => {
        if (res.code === 200) {
          this.$message.success(status === 1 ? '已通过' : '已驳回')
          this.reviewVisible = false
          this.queryData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    auditStatusText(s) {
      return ['待审核', '通过', '驳回', '', '', '', '', '', '已撤销'][s] || '-'
    },
    parseFileList(val) {
      if (!val) return []
      let arr = val
      if (typeof val === 'string') {
        try {
          arr = JSON.parse(val)
        } catch (e) {
          return []
        }
      }
      if (!Array.isArray(arr)) return []
      return arr
    },
    // 审批人预览提交人上传的附件
    previewFile(file) {
      if (!file || !file.url) return
      const suffix = (file.url.split('.').pop() || '').toLowerCase()
      fileViewApi({ url: file.url }).then(res => {
        if (res.code === 200) {
          this.isShowFilePreview = true
          this.fileData = { suffix, fileUrl: res.data.url }
        } else {
          this.$message.warning(res.msg || '预览失败')
        }
      })
    },
    // 审批人下载附件
    handleDownload(file) {
      if (!file || !file.url) return
      downloadFileApi({ url: file.url }).then(res => {
        if (res.code === 200) {
          downloadLinkFile(res.data.url, file.name)
        } else {
          this.$message.warning(res.msg || '下载失败')
        }
      })
    },
    closeFileView() {
      this.isShowFilePreview = false
      this.fileData = {}
    }
  }
}
</script>
